// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 443 ? "about" : chunkId) + "." + {"443":"965cfb7b","586":"d79e2948","715":"61413069","812":"0ed2d814"}[chunkId] + ".css";
};